import type { CSSProperties } from 'react';
import type { DraggableProvidedDraggableProps, DraggableStateSnapshot } from '@hello-pangea/dnd';

/**
 * Style d'un Draggable avec une animation de dépôt COURTE.
 *
 * La lib dure 330–550 ms par défaut (`minDropTime`/`maxDropTime`) — sur un
 * geste répété des dizaines de fois par planning, c'est de l'attente. Le
 * pattern documenté par @hello-pangea/dnd : surcharger `transitionDuration`
 * dans `draggableProps.style` quand `snapshot.isDropAnimating`.
 */
export function dropStyle(
  style: DraggableProvidedDraggableProps['style'],
  snapshot: DraggableStateSnapshot,
): CSSProperties | undefined {
  if (!snapshot.isDropAnimating) return style;
  return { ...style, transitionDuration: '0.2s' };
}
